import React from 'react';
import { Button } from 'primereact/button';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpotify } from '@fortawesome/free-brands-svg-icons';

const Socials = () => {
    const navigate = useNavigate();

    return (
        <>
            <Link to='https://instagram.com/jana_pelikan' target="_blank" rel="noopener noreferrer" className='pr-2'>
                <i className="pi pi-instagram text-100" style={{ fontSize: '2rem' }}></i>
            </Link>
            <Link to='https://www.facebook.com/share/1DrmZjcUWY/?mibextid=LQQJ4d' target="_blank" rel="noopener noreferrer" className='pr-2'>
                <i className="pi pi-facebook text-100" style={{ fontSize: '2rem' }}></i>
            </Link>
            <Link to='https://www.tiktok.com/@jana.pelikan' target="_blank" rel="noopener noreferrer" className='pr-2'>
                <i className="pi pi-tiktok text-100" style={{ fontSize: '2rem' }}></i>
            </Link>
            <Link to='https://www.youtube.com/@janapelikan6186' target="_blank" rel="noopener noreferrer" className='pr-2'>
                <i className="pi pi-youtube text-100" style={{ fontSize: '2rem' }}></i>
            </Link>
            <Link to='https://open.spotify.com/user/j5nsia753e6980q6exgap2bbx?si=vXhbza6WR2qoDz4izQuq4g' target="_blank" rel="noopener noreferrer" className='pr-2 text-white'>
                <FontAwesomeIcon icon={faSpotify} size="2x" />
            </Link>
        </>
    );
};

export default Socials;